import { BusinessDtoKeysEnum } from '@zaoblako/shared/modules/business/enum/business-dto-keys.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';
import { hexColorSchema } from '@zaoblako/shared/modules/serde/schemas/hex-color.schema';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { DealStatusFindInterface } from '@zaoblako/shared/modules/business/dto/deal-status/deal-status-find.dto';

import * as yup from 'yup';

/** Default deal status color */
export const DEAL_STATUS_DEFAULT_COLOR = '#808080';

/** Deal status create or update request body */
export interface DealStatusFormInterface {
  /** Status display name */
  name: string;
  /** If `true` then this status will be initial for the new deals */
  initial?: boolean;
  /** Display color */
  color?: string;
  /** Is status "active" (need for filters) */
  active?: boolean;
  /** If `true`, then the transition of the deal to this status should be accompanied by a comment */
  isCommentRequired?: boolean;
  /** Statuses to which a deal can be transferred from this status */
  transitions?: DealStatusFindInterface[];
}

/** Deal status create or update request body - DTO schema */
export const DealStatusFormDto = SerdeDtoClass.create<DealStatusFormInterface>(BusinessDtoKeysEnum.DEAL_STATUS_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: nonEmptyStringSchema,
  },
  color: {
    optional: true,
    default: DEAL_STATUS_DEFAULT_COLOR,
    label: 'Цвет',
    hint: 'Определяет окраску элементов интерфейса, связанных со статусом',
    serializer: hexColorSchema,
  },
  initial: {
    optional: true,
    label: 'Начальный',
    hint: 'Статус по-умолчанию для новых сделок. Допускается только один начальный статус.',
    serializer: yup.boolean(),
  },
  active: {
    optional: true,
    label: 'Активный',
    hint: 'Если флаг включен, то сделки с этим статусом попадут в "Активные" в некоторых отчетах и виджетах',
    serializer: yup.boolean(),
  },
  isCommentRequired: {
    optional: true,
    label: 'Требуется комментарий',
    hint: 'Если флаг включен, то при переходе сделки в данный статус требуется написать комментарий',
    serializer: yup.boolean(),
  },
  transitions: {
    optional: true,
    label: 'Переход в статусы',
    hint: 'Список статусов, в которые можно перевести сделку в этом статусе',
    serializer: yup.array(entityLikeSchema),
  },
});
